import VerticalLine from '@src/sld/components/Line/VerticalLine';
import { GREEN, RED } from '@src/sld/components/Shared';
import { DataPointWithValue } from '@src/types/DataPoint';
import { ReactElement } from 'react';
import ArrowDown from '../../components/ArrowDown/ArrowDown';
import DeviceDataPointsSection from './DeviceDataPointsSection';

const rectTextProps = {
  fill: 'currentColor',
  stroke: 'none',
  textAnchor: 'right',
  fontSize: '8px',
};

export type BreakerProps = {
  breakerConnected: boolean;
  deviceDataPoints?: DataPointWithValue[] | undefined;
  translateXCoordinate: number;
  translateYCoordinate: number;
  deviceDataPointsSectionXCoordinate: number;
  deviceDataPointsSectionYCoordinate: number;
  feederALabel?: string;
  feederBLabel?: string;
  breakerLabel?: string;
  switchLabel?: string;
  sectionLabel?: string;
  resistorLabel?: string;
};

function BreakerStack(props: BreakerProps): ReactElement {
  const {
    breakerConnected,
    deviceDataPoints,
    translateXCoordinate,
    translateYCoordinate,
    feederALabel,
    breakerLabel,
    sectionLabel,
  } = props;

  return (
    <g transform={`translate(${translateXCoordinate} ${translateYCoordinate})`}>
      <rect
        x={-123}
        y='723'
        width='20'
        height='20'
        fill={breakerConnected ? RED : GREEN}
        strokeWidth={0.5}
      />

      <text x={-90} y={735} {...rectTextProps}>
        {breakerLabel}
      </text>

      <VerticalLine
        translateXCoordinate={-113.5}
        translateYCoordinate={744}
        length={50}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />

      <ArrowDown xCoordinate={-116} yCoordinate={795} />

      <text x={-180} y={820} fill='currentColor' stroke='none' fontSize='8px'>
        {feederALabel}
      </text>

      <DeviceDataPointsSection
        translateXCoordinate={-160}
        translateYCoordinate={880}
        deviceDataPoints={deviceDataPoints}
        label={sectionLabel || ''}
      />
    </g>
  );
}

export default BreakerStack;
